<template>
  <q-page class="q-pa-md bg-grey-2">
    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="subscriptions" class="q-mr-sm" size="sm" />
          Listado de Planes
        </div>
        <q-btn
          color="white"
          text-color="primary"
          icon="add"
          label="Agregar Plan"
          unelevated
          rounded
          class="text-weight-bold"
          @click="AbrirNueva"
        />
      </q-card-section>

      <q-card-section class="q-pa-none">
        <q-table
          :data="ListaPlanes"
          :columns="columns"
          row-key="idplan"
          :pagination.sync="pagination"
          flat
          bordered
          no-data-label="No hay planes disponibles"
        >
          <template v-slot:body-cell-precio="props">
            <q-td :props="props" class="text-right text-weight-bold text-primary">
              S/ {{ props.value }}
            </q-td>
          </template>

          <template v-slot:body-cell-actions="props">
            <q-td :props="props" class="text-right">
              <q-btn
                flat
                round
                color="primary"
                icon="edit"
                size="sm"
                @click="Editar(props.row.idplan)"
              >
                <q-tooltip>Editar Plan</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      pagination: { rowsPerPage: 50 },
      ListaPlanes: [],
      columns: [
        { name: "idplan", label: "ID", field: "idplan", align: "left", sortable: true },
        { name: "nombre", label: "Nombre del Plan", field: "nombre", align: "left", sortable: true },
        { name: "tipo", label: "Tipo", field: "tipo", align: "left" },
        { name: "precio", label: "Precio", field: "precio", align: "right" },
        { name: "nconsultas", label: "Consultas", field: "nconsultas", align: "center" },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.Listar();
  },
  methods: {
    Editar(id) {
      this.$router.push("/aveo/Plan/PlanesEditar/" + id);
    },
    AbrirNueva() {
      this.$router.push("/aveo/Plan/PlanesAgregar");
    },
    Listar() {
      let me = this;
      axios
        .get("ApiWeb/PlanLista.php")
        .then(function(response) {
          me.ListaPlanes = response.data.data || [];
        })
        .catch(function(error) {
          console.error(error);
        });
    },
  },
};
</script>
